import TopicPageTemplate from '@templates/topic-page/detail';

// ---------------------------------------------------------

import FlexibleDataOptimized, { fetchTopicPaths } from '@lib/cms/flexibleDataOptimized';

// ---------------------------------------------------------

export async function getStaticPaths() {
  const pathData = await fetchTopicPaths('Relocation');

  const EXCLUDED_SLUGS = ['relocation-index'];

  const slugs = pathData
    .filter((item) => {
      if (EXCLUDED_SLUGS.includes(item.slug)) return false;
      return true;
    })
    .map((item) => {
      return {
        params: { slug: item.slug }
      };
    });

  return {
    fallback: false,
    paths: slugs
  };
}

export async function getStaticProps(context) {
  const preview = context.preview || false;
  const previewEnv = context?.previewData?.environment || null;
  const pageData = await FlexibleDataOptimized.fetchTopicPage(
    'Relocation',
    context.params.slug,
    preview,
    previewEnv
  );

  return {
    props: { pageData, preview }
  };
}

// ---------------------------------------------------------

const Home = ({ pageData, preview }) => {
  return (
    <TopicPageTemplate
      collection="Relocation"
      coreService
      pageData={pageData}
      preview={preview}
    ></TopicPageTemplate>
  );
};

export default Home;
